(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["company-purchase-fields"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('company-purchase')) {
    class CompanyPurchase extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.initialized) return;

        this.fields = this.querySelector('.company-purchase__fields');
        this.companyField = this.querySelector('[data-company-field]');
        this.nipField = this.querySelector('[data-nip-field]');
        this.nipError = this.querySelector('[data-nip-error]');
        this.status = this.querySelector('[data-status]');
        if (!this.fields || !this.companyField || !this.nipField) return;

        this.form = this.closest('form') || document.getElementById(this.companyField?.getAttribute('form'));
        this.initialized = true;

        this.addEventListener('change', this.handleChange.bind(this));
        this.companyField?.addEventListener('blur', this.persist.bind(this));
        this.nipField?.addEventListener('blur', this.handleNipBlur.bind(this));
        this.form?.addEventListener('submit', this.handleSubmit.bind(this));
        this.applyMode(false);
      }

      get isBusiness() {
        return this.querySelector('input[name="attributes[Typ zakupu]"]:checked')?.value === 'Firma';
      }

      handleChange(event) {
        if (event.target.name === 'attributes[Typ zakupu]') {
          this.applyMode(true);
        }
      }

      applyMode(shouldPersist) {
        const business = this.isBusiness;
        this.dataset.mode = business ? 'business' : 'private';
        this.fields.hidden = !business;
        this.companyField.required = business;
        this.nipField.required = business;
        this.companyField.setAttribute('aria-required', String(business));
        this.nipField.setAttribute('aria-required', String(business));
        if (!business) {
          this.companyField.value = '';
          this.nipField.value = '';
          this.nipField.setCustomValidity('');
        }

        if (shouldPersist) this.persist();
      }

      handleNipBlur() {
        this.nipField.value = this.nipField.value.replace(/\D/g, '').slice(0, 10);
        this.validateNip();
        this.persist();
      }

      validateNip() {
        if (!this.isBusiness) {
          this.nipField.setCustomValidity('');
          return true;
        }

        const nip = this.nipField.value;
        const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
        const checksum = nip.length === 10
          ? weights.reduce((sum, weight, index) => sum + Number(nip[index]) * weight, 0) % 11
          : -1;
        const valid = /^\d{10}$/.test(nip) && checksum !== 10 && checksum === Number(nip[9]);
        this.nipField.setCustomValidity(valid ? '' : this.nipError.textContent.trim());
        return valid;
      }

      handleSubmit(event) {
        if (!this.isBusiness) return;
        this.validateNip();
        if (!this.form.checkValidity()) {
          event.preventDefault();
          this.form.reportValidity();
        }
      }

      async persist() {
        const attributes = {
          'Typ zakupu': this.isBusiness ? 'Firma' : 'Prywatny',
          Firma: this.isBusiness ? this.companyField.value.trim() : '',
          NIP: this.isBusiness ? this.nipField.value : '',
          'Faktura VAT': this.isBusiness ? 'Tak' : 'Nie'
        };

        try {
          const response = await fetch(this.dataset.updateUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ attributes })
          });
          if (!response.ok) throw new Error(String(response.status));
          this.status.classList.add('visually-hidden');
        } catch (error) {
          this.status.classList.remove('visually-hidden');
        }
      }
    }

    customElements.define('company-purchase', CompanyPurchase);
  }
  } catch(e) { console.error(e); }
})();

})();
